export enum PaymentStatuses {
  NotProcessed = 0,
  Success = 1,
  Failure = 2,
  Abandoned = 3,
}
